// Back/forward navigation buttons for the word history stack (managed by useWordsNav).
import { PmsTooltip } from '@/components/ui/pms-tooltip';
import { useWordsNav } from '@/lib/words-nav';

/** Back and forward buttons that navigate the word history stack. */
export function TopbarNav() {
  const nav = useWordsNav();
  return (
    <div className="words-topbar__nav">
      <PmsTooltip label="Précédent" side="bottom">
        <button
          className="words-nav-btn"
          aria-label="Précédent"
          disabled={!nav.canBack}
          onClick={nav.goBack}
          type="button"
        >
          <span className="material-symbols-rounded">arrow_back</span>
        </button>
      </PmsTooltip>
      <PmsTooltip label="Suivant" side="bottom">
        <button
          className="words-nav-btn"
          aria-label="Suivant"
          disabled={!nav.canForward}
          onClick={nav.goForward}
          type="button"
        >
          <span className="material-symbols-rounded">arrow_forward</span>
        </button>
      </PmsTooltip>
    </div>
  );
}
